export default __webpack_public_path__ + "static/media/icon-https.e22f5d7a.svg";